// LUMINA · pages/vajra/ServiceHub.jsx
// Phase 71: 服务聚合 — 随喜供养 · 祈请法事 · 法宝流通 · 联系我们
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API, GD, GDL, DG, BG, TXT, TXT2 } from './constants';
import VajraShop from './VajraShop';
import DharmaRequestForm from './components/DharmaRequestForm';
const PANEL = "#ffffff";

// ── Section wrapper ──
function Section({ icon, title, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{ background: PANEL, borderRadius: 12, border: "1px solid rgba(212,175,55,0.15)", marginBottom: 10, overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
      <button onClick={() => setOpen(!open)} style={{ width: "100%", display: "flex", alignItems: "center", gap: 10, padding: "14px 18px", background: "none", border: "none", cursor: "pointer", fontSize: 14, color: TXT, fontWeight: 600, letterSpacing: ".5px" }}>
        <span style={{ fontSize: 18 }}>{icon}</span> {title}
        <span style={{ marginLeft: "auto", fontSize: 12, color: TXT2, opacity: 0.5, transition: "transform .2s", transform: open ? "rotate(180deg)" : "none" }}>▼</span>
      </button>
      {open && <div style={{ padding: "0 18px 18px" }}>{children}</div>}
    </div>
  );
}

// ── 1. 随喜供养 ──
function OfferingCompact({ token, member, lang }) {
  const [targets, setTargets] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API}/vajra/offerings/targets`).then(r => r.ok ? r.json() : []).then(setTargets).catch(() => { });
  }, []);

  return (
    <div>
      <div style={{ fontSize: 12, color: TXT2, marginBottom: 12 }}>{lang === "en" ? "Choose an offering target to support the dharma." : "选择供养对象，以随喜之心护持法务。"}</div>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {targets.length === 0 && <span style={{ fontSize: 12, color: TXT2, opacity: 0.5 }}>{lang === "en" ? "No offering targets available" : "暂无供养对象"}</span>}
        {targets.map(t => (
          <button key={t.id} onClick={() => navigate(`/vajra/offering/${t.id}`)} style={{ padding: "5px 12px", borderRadius: 20, fontSize: 11, border: "1px solid rgba(0,0,0,0.12)", background: "transparent", color: TXT2, cursor: "pointer" }}>
            {t.name_zh}
          </button>
        ))}
      </div>
    </div>
  );
}

// ── 往期供养回顾 ──
function OfferingHistory() {
  const [items, setItems] = useState([]);
  const [lightbox, setLightbox] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API}/vajra/offerings/history`)
      .then(r => r.ok ? r.json() : [])
      .then(d => setItems(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, []);

  if (items.length === 0) return (
    <div style={{ fontSize: 12, color: TXT2, opacity: 0.5 }}>暂无往期供养记录</div>
  );

  return (
    <div>
      <div style={{ fontSize: 12, color: TXT2, marginBottom: 12 }}>
        已圆满的供养项目，以此回顾善法功德。
      </div>
      {items.map(item => (
        <div key={item.id} style={{ marginBottom: 24 }}>
          <div onClick={() => navigate(`/vajra/offering/${item.id}`)} style={{
            display: "flex", alignItems: "baseline", gap: 8,
            marginBottom: 10, cursor: "pointer", flexWrap: "wrap",
          }}>
            <span style={{
              fontSize: 10, letterSpacing: 1.5, padding: "2px 10px", borderRadius: 10,
              background: "rgba(139,105,20,0.08)", color: GD,
              border: "1px solid rgba(139,105,20,0.15)",
            }}>
              {item.target_type === "monastery" ? "寺院" :
               item.target_type === "teacher" ? "上师" :
               item.target_type === "remote_puja" ? "远程法事" : "项目"}
            </span>
            <span style={{ fontSize: 14, fontWeight: 600, color: TXT }}>
              {item.name_zh}
            </span>
            {item.temple_name && (
              <span style={{ fontSize: 11, color: TXT2 }}>📍 {item.temple_name}</span>
            )}
          </div>
          {(item.gallery_images || []).length > 0 && (
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
              gap: 8,
            }}>
              {item.gallery_images.map((url, i) => (
                <div key={i} onClick={() => setLightbox({ images: item.gallery_images, idx: i })} style={{
                  position: "relative", overflow: "hidden",
                  borderRadius: 8, cursor: "pointer",
                  aspectRatio: "4/3",
                  border: "1px solid rgba(0,0,0,0.06)",
                  background: BG,
                }}>
                  <img src={url} alt={`${item.name_zh} ${i + 1}`}
                    style={{
                      width: "100%", height: "100%", objectFit: "cover",
                      transition: "transform 0.3s",
                    }}
                    onMouseOver={e => e.currentTarget.style.transform = "scale(1.05)"}
                    onMouseOut={e => e.currentTarget.style.transform = "scale(1)"}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
      {/* Lightbox */}
      {lightbox && (
        <div onClick={() => setLightbox(null)} style={{
          position: "fixed", inset: 0, zIndex: 2000,
          background: "rgba(0,0,0,0.92)", display: "flex",
          alignItems: "center", justifyContent: "center", cursor: "pointer",
        }}>
          <button onClick={e => { e.stopPropagation(); setLightbox(null); }} style={{
            position: "absolute", top: 20, right: 24,
            background: "none", border: "none", color: "#fff",
            fontSize: 28, cursor: "pointer", opacity: 0.7,
          }}>✕</button>
          {lightbox.idx > 0 && (
            <button onClick={e => { e.stopPropagation(); setLightbox(l => ({ ...l, idx: l.idx - 1 })); }} style={{
              position: "absolute", left: 16, top: "50%", transform: "translateY(-50%)",
              background: "rgba(255,255,255,0.1)", border: "none", color: "#fff",
              fontSize: 32, cursor: "pointer", borderRadius: 8, padding: "8px 14px",
            }}>‹</button>
          )}
          <img src={lightbox.images[lightbox.idx]} alt=""
            onClick={e => e.stopPropagation()}
            style={{ maxWidth: "90vw", maxHeight: "85vh", borderRadius: 8, objectFit: "contain", cursor: "default" }} />
          {lightbox.idx < lightbox.images.length - 1 && (
            <button onClick={e => { e.stopPropagation(); setLightbox(l => ({ ...l, idx: l.idx + 1 })); }} style={{
              position: "absolute", right: 16, top: "50%", transform: "translateY(-50%)",
              background: "rgba(255,255,255,0.1)", border: "none", color: "#fff",
              fontSize: 32, cursor: "pointer", borderRadius: 8, padding: "8px 14px",
            }}>›</button>
          )}
          <div style={{ position: "absolute", bottom: 20, color: "rgba(255,255,255,0.5)", fontSize: 12 }}>
            {lightbox.idx + 1} / {lightbox.images.length}
          </div>
        </div>
      )}
    </div>
  );
}
function ContactForm({ token, member, lang }) {
  const [form, setForm] = useState({ subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!form.subject.trim()) { setErr("请填写主题"); return; }
    if (!form.message.trim()) { setErr("请填写内容"); return; }
    const h = { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" };
    const body = { sender_name: member?.dharma_name || member?.name || "", sender_email: member?.email || "", subject: form.subject, message: form.message };
    const r = await fetch(`${API}/vajra/contact`, { method: "POST", headers: h, body: JSON.stringify(body) });
    if (r.ok) { setSent(true); setErr(""); }
    else { const d = await r.json().catch(() => { }); setErr(d?.detail || "发送失败"); }
  };

  if (sent) return (
    <div style={{ padding: "12px 0", textAlign: "center" }}>
      <div style={{ fontSize: 14, color: DG, marginBottom: 4 }}>✓ {lang === "en" ? "Message sent" : "讯息已发送"}</div>
      <div style={{ fontSize: 12, color: TXT2 }}>{lang === "en" ? "We will reply as soon as possible." : "我们会尽快回复您。"}</div>
      <button onClick={() => { setSent(false); setForm({ subject: "", message: "" }); }} style={{ marginTop: 8, fontSize: 11, color: GD, background: "none", border: "none", cursor: "pointer" }}>{lang === "en" ? "Send another" : "再次发送"}</button>
    </div>
  );

  return (
    <div>
      <div style={{ fontSize: 12, color: TXT2, marginBottom: 12 }}>{lang === "en" ? "Dharma questions · Practice guidance · Dharma requests — contact us." : "法教疑问 · 修行指导 · 法事请求 — 请联系我们。"}</div>
      <form onSubmit={submit}>
        <input placeholder={lang === "en" ? "Subject" : "主题"} value={form.subject} onChange={e => setForm({ ...form, subject: e.target.value })} style={{ display: "block", width: "100%", maxWidth: 420, border: "1px solid rgba(0,0,0,0.15)", borderRadius: 6, padding: "7px 10px", fontSize: 12, marginBottom: 8, boxSizing: "border-box" }} />
        <textarea placeholder={lang === "en" ? "Your message…" : "请输入您的讯息…"} value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} rows={4} style={{ display: "block", width: "100%", maxWidth: 420, border: "1px solid rgba(0,0,0,0.15)", borderRadius: 6, padding: "8px 10px", fontSize: 12, marginBottom: 8, resize: "vertical", boxSizing: "border-box" }} />
        {err && <div style={{ color: CR, fontSize: 11, marginBottom: 6 }}>{err}</div>}
        <button type="submit" style={{ background: GD, color: "#fff", border: "none", borderRadius: 6, padding: "7px 20px", fontSize: 12, cursor: "pointer", letterSpacing: ".5px" }}>{lang === "en" ? "Send Message" : "发送讯息"}</button>
      </form>
    </div>
  );
}

// ── Main ──
export default function ServiceHub({ token, member, lang, T }) {
  const t = T || {};
  const [requestTypes, setRequestTypes] = useState([]);
  useEffect(() => {
    fetch(`${API}/vajra/request-types`)
      .then(r => r.ok ? r.json() : [])
      .then(d => setRequestTypes(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, []);

  return (
    <div style={{ padding: "24px 0" }}>
      <div style={{ fontSize: 11, color: TXT2, opacity: 0.5, letterSpacing: 3, textTransform: "uppercase", marginBottom: 16 }}>
        {lang === "en" ? "Community Services" : "社群服务"}
      </div>

      <Section icon="🙏" title={t.serviceOfferings || "随喜供养"} defaultOpen={true}>
        <OfferingCompact token={token} member={member} lang={lang} />
        <div style={{ marginTop: 20, paddingTop: 16, borderTop: "1px solid rgba(212,175,55,0.15)" }}>
          <div style={{ fontSize: 12, color: GDL, fontWeight: 600, letterSpacing: 1, marginBottom: 12 }}>
            ☸ BTF CANADA {lang === "en" ? "Daily Operations" : "日常运作供养"}
          </div>
          <div style={{ fontSize: 11, color: TXT2, lineHeight: 1.8, marginBottom: 14 }}>
            {lang === "en"
              ? "Your offering supports the BTF Canada Vajra Community's daily operations: venues, dharma text printing, and online platform. Every contribution, large or small, plants seeds of virtue."
              : "您的随喜供养支持如意宝金刚社群的日常运营：场地、法本印制、线上平台维护。无论金额大小，皆是护持正法的殊胜福田。"}
          </div>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center", marginBottom: 14 }}>
            {[
              { label: "PayPal", info: "canada.btf@gmail.com" },
              { label: "E-transfer", info: "canada.btf@gmail.com" },
            ].map(p => (
              <span key={p.label} style={{
                fontSize: 11, color: TXT2, padding: "4px 12px",
                borderRadius: 14, background: "rgba(139,105,20,0.05)",
                border: "1px solid rgba(139,105,20,0.15)"
              }}>
                {p.label}: {p.info}
              </span>
            ))}
            <span style={{
              fontSize: 11, color: TXT2, padding: "4px 12px",
              borderRadius: 14, background: "rgba(139,105,20,0.05)",
              border: "1px solid rgba(139,105,20,0.15)"
            }}>
              WeChat: jxuabc
            </span>
          </div>
          <div style={{ textAlign: "center" }}>
            <img src="/wechat-qr.png" alt="WeChat Pay QR"
              style={{
                width: 120, height: 120, borderRadius: 12,
                border: "2px solid rgba(212,175,55,0.2)",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
              }} />
            <div style={{ fontSize: 9, color: TXT2, opacity: 0.5, marginTop: 4 }}>
              {lang === "en" ? "Scan to offer via WeChat" : "微信扫码供养"}
            </div>
          </div>
        </div>
      </Section>

      <Section icon="🪷" title={t.serviceRequests || "祈请法事"}>
        <DharmaRequestForm token={token} member={member} requestTypes={requestTypes} />
      </Section>

      <Section icon="🏺" title={t.serviceShop || "法宝流通"}>
        <VajraShop lang={lang}/>
      </Section>

      <Section icon="📸" title={lang === "en" ? "Past Offerings" : "往期供养回顾"}>
        <OfferingHistory />
      </Section>

      <Section icon="✉️" title={t.serviceContact || "联系我们"}>
        <ContactForm token={token} member={member} lang={lang} />
        <div style={{ marginTop: 16, paddingTop: 14, borderTop: "1px solid rgba(212,175,55,0.12)" }}>
          <a href="/vajra#faq" style={{ fontSize: 11, color: GD, textDecoration: "none", letterSpacing: .5, opacity: .7 }}
            onClick={(e) => { e.preventDefault(); document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' }); }}>
            ❓ 常见问题 →
          </a>
        </div>
      </Section>
    </div>
  );
}
